'use client';
import React, { useEffect } from "react";
import Script from "next/script";
import { useRouter, usePathname } from "next/navigation";
import * as gtag from "@/lib/gtag";
import * as fbq from "@/lib/fb-pixel";
import type { ScriptsPixels } from "@/utils/strapi/sections/ScriptPixel";

const Pixel = (props: ScriptsPixels) => {
  const router = useRouter();
  const pathname = usePathname();
  const {
    script,
    pixel,
    src,
    async,
    name,
    enabled = true,
    triggerOnRouteChange,
    crossorigin = false,
    integrity = undefined,
    strategy = "afterInteractive"
  } = props;

  useEffect(() => {
    if (triggerOnRouteChange === "gtagPageview") {
      gtag.pageview(pathname);
    } else if (triggerOnRouteChange === "fbqPageview") {
      fbq.pageview();
    }
  }, [pathname, triggerOnRouteChange]);

  return (
    <>
      {enabled && !!pixel &&
        <noscript>
          {
            !!pixel.element &&
            (
              pixel.element === 'img' && <img height="1" width="1" style={{ display: 'none' }} src={pixel.src} />
              ||
              pixel.element === 'iframe' && <iframe src={pixel.src} height="0" width="0" style={{ "display": "none", "visibility": "hidden" }}></iframe>
            )
          }
        </noscript>
      }
      {
        enabled && (!!src && !script) &&
        <Script
          id={name}
          src={src}
          async={async}
          crossOrigin={crossorigin ? "anonymous" : undefined}
          strategy={strategy}
          {...(integrity ? { integrity } : {})}
        />
      }
      {
        enabled && (!!script && !src) &&
        <Script
          id={name}
          async={async}
          crossOrigin={crossorigin ? "anonymous" : undefined}
          dangerouslySetInnerHTML={{ __html: script }}
          strategy={strategy}
          {...(integrity ? { integrity } : {})}
        />
      }
      {
        enabled && (!!script && !!src) &&
        <Script
          id={name}
          src={src}
          async={async}
          crossOrigin={crossorigin ? "anonymous" : undefined}
          dangerouslySetInnerHTML={{ __html: script }}
          strategy={strategy}
          {...(integrity ? { integrity } : {})}
        />
      }
    </>
  )
};

export default Pixel;